import { LABELS, config } from '@app/config';
import { datadogRum } from '@datadog/browser-rum-slim';
import { isUserAgentNonInteractive } from '@app/ui';

const convertNsToSeconds = (ns) => {
  if (!ns) {
    return '--';
  }

  return `${ns / 1000000000}s`;
};

const summarizeViewMetrics = (view) => {
  const values = [
    ['Loading Time', convertNsToSeconds(view.loading_time)],
    ['Load Event', convertNsToSeconds(view.load_event)],
    ['Long Task Count', view.long_task.count],
    [
      'Critical Page Action',
      convertNsToSeconds(view.custom_timings['page.critical']),
    ],
  ];

  // eslint-disable-next-line no-console
  console.table(values);
};

const initDataDog = (): void => {
  const {
    SERVICES: { DATA_DOG_RUM },
    ENVIRONMENT,
  } = config;

  if (isUserAgentNonInteractive(window.navigator.userAgent)) {
    return;
  }

  // We use the domain to check if we are in production, so we aren't under sampling our production like env (iron.beta)
  const isProduction = window.location.host.includes('stockx.com');
  const enableDebug = window.location.search.includes('datadogDebug');

  try {
    datadogRum.init({
      applicationId: DATA_DOG_RUM.APP_ID,
      clientToken: DATA_DOG_RUM.CLIENT_TOKEN,
      sampleRate: isProduction ? 5 : 100,
      premiumSampleRate: 0,
      env: ENVIRONMENT,
      version: LABELS.APP_HUMAN_VERSION,
      trackViewsManually: true,
      trackInteractions: false,
      beforeSend: (event) => {
        if (enableDebug && event.view.loading_time) {
          summarizeViewMetrics(event.view);
        }
      },

      service: 'iron',
      // commented this out as auth0 password reset flow does not allow the "x-datadog" header
      // allowedTracingOrigins: [/https:\/\/.*\.stockx\.io/, /https:\/\/.*\.stockx\.com/],
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
    // noop
  }
};

export default initDataDog;
